import React, { Component } from 'react';
import { getCachedBranchSettings, setCachedBranchSettings } from '../utils/branch';

var config = process.env;

class BranchSettingsComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            branches: [],
            loading: true,
            editingId: null,
            name: '',
            address: '',
            phone: '',
            showModal: false,
            isSubmitting: false,
        };
    }

    componentDidMount() {
        this.loadBranches();
    }

    loadBranches = () => {
        const cachedBranches = getCachedBranchSettings();
        this.setState({
            loading: cachedBranches == null,
            ...(cachedBranches != null ? { branches: cachedBranches } : {}),
        });

        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'branch', {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        })
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                return;
            }

            const branches = data.data || [];
            setCachedBranchSettings(branches);
            this.setState({
                branches,
                loading: false,
            });
        })
        .catch(() => {
            this.setState({ loading: false });
        });
    }

    resetForm = () => {
        this.setState({
            editingId: null,
            name: '',
            address: '',
            phone: '',
            showModal: false,
            isSubmitting: false,
        });
    }

    openCreateModal = () => {
        this.setState({
            editingId: null,
            name: '',
            address: '',
            phone: '',
            showModal: true,
        });
    }

    onEdit = (branch) => {
        this.setState({
            editingId: branch.id,
            name: branch.name || '',
            address: branch.address || '',
            phone: branch.phone || '',
            showModal: true,
        });
    }

    closeModal = () => {
        if (this.state.isSubmitting) {
            return;
        }

        this.resetForm();
    }

    onSubmit = () => {
        const payload = {
            name: this.state.name,
            address: this.state.address,
            phone: this.state.phone,
        };

        const isEditing = this.state.editingId != null;
        const url = isEditing
            ? `${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}branch/${this.state.editingId}`
            : `${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}branch`;

        this.setState({ isSubmitting: true });

        fetch(url, {
            method: isEditing ? 'PATCH' : 'POST',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                return;
            }

            this.resetForm();
            this.loadBranches();
        })
        .finally(() => {
            this.setState({ isSubmitting: false });
        });
    }

    onDeactivate = (branchId) => {
        if (!window.confirm('Se va a desactivar la sucursal. Continuar?')) {
            return;
        }

        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}branch/${branchId}`, {
            method: 'DELETE',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            },
        })
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                return;
            }

            this.loadBranches();
        });
    }

    renderLoader = () => {
        return (
            <div
                style={{
                    minHeight: '280px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2rem',
                }}
            >
                <div className="containerLoader" style={{ display: 'block', position: 'static', width: '100%' }}>
                    <div className="loader"></div>
                </div>
            </div>
        );
    }

    renderEmptyState = () => {
        return (
            <div
                style={{
                    minHeight: '280px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2rem',
                }}
            >
                <div style={{ textAlign: 'center', maxWidth: '420px' }}>
                    <div
                        style={{
                            width: '72px',
                            height: '72px',
                            margin: '0 auto 1rem',
                            borderRadius: '50%',
                            background: '#f5f6f8',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <i className="material-icons" style={{ fontSize: '34px', color: '#818ea3' }}>storefront</i>
                    </div>
                    <h4 style={{ marginBottom: '0.75rem', color: '#3d5170', fontWeight: 500 }}>
                        Todavía no hay sucursales cargadas
                    </h4>
                    <p style={{ margin: 0, color: '#818ea3', lineHeight: 1.6 }}>
                        Creá una nueva sucursal para empezar a administrar stock y movimientos por ubicación.
                    </p>
                </div>
            </div>
        );
    }

    renderTable = () => {
        if (this.state.loading) {
            return this.renderLoader();
        }

        if (this.state.branches.length === 0) {
            return this.renderEmptyState();
        }

        return (
            <div className="table-responsive">
                <table className="table mb-0">
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Dirección</th>
                            <th>Teléfono</th>
                            <th>Estado</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.branches.map((branch) => (
                            <tr key={branch.id}>
                                <td className="font-weight-bold">{branch.name}</td>
                                <td>{branch.address || 'Sin dirección'}</td>
                                <td>{branch.phone || 'Sin teléfono'}</td>
                                <td>{branch.isActive ? 'Activa' : 'Inactiva'}</td>
                                <td className="text-right">
                                    <button className="btn btn-sm btn-outline-primary mr-2" onClick={() => this.onEdit(branch)}>
                                        Editar
                                    </button>
                                    {branch.id !== 1 && branch.isActive ? (
                                        <button className="btn btn-sm btn-outline-danger" onClick={() => this.onDeactivate(branch.id)}>
                                            Desactivar
                                        </button>
                                    ) : null}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }

    renderModal = () => {
        if (!this.state.showModal) {
            return null;
        }

        const isEditing = this.state.editingId != null;

        return (
            <>
                <div className="modal fade show" style={{ display: 'block' }} role="dialog">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content" style={{ borderRadius: '0.75rem' }}>
                            <div className="modal-header">
                                <div>
                                    <h4 className="modal-title mb-1">{isEditing ? 'Editar sucursal' : 'Nueva sucursal'}</h4>
                                    <small className="text-muted">
                                        Completá los datos principales de la sucursal.
                                    </small>
                                </div>
                                <button type="button" className="close" aria-label="Close" onClick={this.closeModal}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group">
                                    <label>Nombre</label>
                                    <input
                                        className="form-control"
                                        value={this.state.name}
                                        onChange={(event) => this.setState({ name: event.target.value })}
                                        placeholder="Principal"
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Dirección</label>
                                    <input
                                        className="form-control"
                                        value={this.state.address}
                                        onChange={(event) => this.setState({ address: event.target.value })}
                                        placeholder="Dirección física"
                                    />
                                </div>
                                <div className="form-group mb-0">
                                    <label>Teléfono</label>
                                    <input
                                        className="form-control"
                                        value={this.state.phone}
                                        onChange={(event) => this.setState({ phone: event.target.value })}
                                        placeholder="Teléfono"
                                    />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-outline-secondary" onClick={this.closeModal} disabled={this.state.isSubmitting}>
                                    Cancelar
                                </button>
                                <button className="btn btn-primary" onClick={this.onSubmit} disabled={this.state.isSubmitting}>
                                    {isEditing ? 'Guardar cambios' : 'Crear sucursal'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade show"></div>
            </>
        );
    }

    render() {
        return (
            <>
                <div className="card">
                    <div className="d-flex justify-content-between align-items-center border-bottom" style={{ padding: '1rem 1.5rem' }}>
                        <span className="text-muted" style={{ fontSize: '0.95rem' }}>
                            Administrá las sucursales activas del sistema y su stock total asociado.
                        </span>
                        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={this.loadBranches}>
                            Recargar
                        </button>
                    </div>
                    <div className="card-body p-0">
                        {this.renderTable()}
                    </div>
                </div>
                <div onClick={this.openCreateModal} className="color-switcher-toggle animated pulse infinite">
                    <i className="material-icons">add</i>
                </div>
                {this.renderModal()}
            </>
        );
    }
}

export default BranchSettingsComponent;
